import {BaseCachedService} from './Core/BaseCachedService';

class ContactMethodService extends BaseCachedService {
    get Url() { return super.Url + "/contactMethods"; }
}

export const service = new ContactMethodService();

